
import { useState, useEffect } from 'react';
import { usePatients } from './usePatients';

export interface UpcomingAppointment {
  id: string;
  patientId: number;
  patientName: string;
  date: Date | string;
  type: 'clinic' | 'video' | 'voice';
}

export const useDashboardActivities = () => {
  const { patients } = usePatients();
  const [upcomingAppointments, setUpcomingAppointments] = useState<UpcomingAppointment[]>([]);
  const [completedTreatments, setCompletedTreatments] = useState(0);
  const [hasActivities, setHasActivities] = useState(false);
  
  useEffect(() => {
    // This would typically come from an API call in a real application
    // For this demo, we'll create mock data

    // Generate upcoming appointments for the next 24 hours
    const mockAppointments: UpcomingAppointment[] = [
      {
        id: "apt-1",
        patientId: 1,
        patientName: "Emily Johnson",
        date: new Date(Date.now() + 1000 * 60 * 60 * 2).toISOString(), // 2 hours from now
        type: "video"
      },
      {
        id: "apt-2",
        patientId: 2,
        patientName: "Michael Chen",
        date: new Date(Date.now() + 1000 * 60 * 60 * 4).toISOString(), // 4 hours from now
        type: "clinic"
      },
      {
        id: "apt-3",
        patientId: 3,
        patientName: "Sarah Williams",
        date: new Date(Date.now() + 1000 * 60 * 60 * 6).toISOString(), // 6 hours from now
        type: "voice"
      }
    ];

    setUpcomingAppointments(mockAppointments);
    
    // Count completed treatments this month
    const completedCount = patients.filter(p => 
      p.status === 'completed' && 
      new Date(p.date).getMonth() === new Date().getMonth()
    ).length;
    
    setCompletedTreatments(completedCount);
    setHasActivities(true);
    
  }, [patients]);

  return {
    upcomingAppointments,
    completedTreatments,
    newCasesThisWeek: patients.filter(p => 
      p.status === 'new' && 
      (new Date(p.date).getTime() > Date.now() - 7 * 24 * 60 * 60 * 1000)
    ).length,
    acceptedPatients: patients.filter(p => 
      p.status === 'in-treatment' || p.status === 'in-progress'
    ).length,
    hasActivities
  };
};
